import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SkipToContent } from "./SkipToContent";
import { SiteNav } from "./SiteNav";
import { SiteFooter } from "./SiteFooter";

/**
 * Wraps every dark-surface route. Legal pages use <LegalLayout /> instead.
 */
export function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-surface-base text-ink-primary">
      <SkipToContent targetId="main-content" />
      <SiteNav variant="on-dark" />
      {/* Spacer = nav height only. Nav 57 mobile / 65 md+lg (content + 1px border). */}
      <div className="h-[57px] md:h-[65px]" aria-hidden />
      <main
        id="main-content"
        tabIndex={-1}
        className="focus:outline-none scroll-mt-[57px] md:scroll-mt-[65px]"
      >
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}

export default SiteLayout;
